import { render, staticRenderFns } from "./Convocatory.vue?vue&type=template&id=5483304c&scoped=true"
import script from "./Convocatory.vue?vue&type=script&lang=js"
export * from "./Convocatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483304c",
  null
  
)

export default component.exports